<!--
 * @Description:
 * @LastEditors: Please set LastEditors
 * @Date: 2020-11-03 09:41:19
-->
<template>
  <div>
    <div v-if="type == 'projectAsideList'" class="nav">
      <img
        style="width: 24px;height: 24px"
        class="hand"
        src="http://cdn.yxvzb.com/WEB/images/home%20(1).png"
        @click="goHome"
      />
      <span class="s1 hand" @click="goHome">首页</span>
      <span class="s2">{{ projectTypeName }}</span>
      <i style="font-size:14px;" class="el-icon-arrow-right"></i>
      <span class="s2" style="color: #666666;">{{ projectName }}</span>
    </div>
    <div v-else-if="type == 'orderAsideList'" class="nav">
      <span class="s1 hand" @click="goAccount" style="margin-right:0">
        结算中心
      </span>
      <i style="font-size:14px;" class="el-icon-arrow-right"></i>
      <span class="s2" style="color: #666666;">{{ $route.meta.name }}</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      // breadcrumbList: []
    };
  },
  props: {
    type: {
      type: [Number, String],
      default: ''
    }
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
    },
    goAccount() {
      this.$router.push({ name: 'account' });
    }
  },
  computed: {
    ...mapState({
      projectTypeName: state => state.homeProject.projectTypeName,
      projectName: state => state.homeProject.projectName
    })
  },
  watch: {},
  components: {},
  created() {}
};
</script>
<style lang="scss" scoped>
.nav {
  display: flex;
  align-items: center;
  img {
    width: 27px;
    height: 27px;
    margin-right: 5px;
  }
  .s1 {
    font-size: 16px;
    color: #1989fa;
    line-height: 1;
    margin-right: 15px;
  }
  .s2 {
    font-size: 16px;
    color: #343333;
    line-height: 1;
  }
}
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
/*fade*/

// .breadcrumb-enter-active,
// .breadcrumb-leave-active {
//   transition: all 0.5s;
// }

// .breadcrumb-enter,
// .breadcrumb-leave-active {
//   opacity: 0;
//   transform: translateX(20px);
// }

// .breadcrumb-move {
//   transition: all 0.5s;
// }

// .breadcrumb-leave-active {
//   position: absolute;
// }
</style>
